import React from "react";

const NewHomes = () => {
  return (
    <>
      <h1>New Homes</h1>
    </>
  );
};

export default NewHomes;
